import type React from 'react';

import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';
import { ResponsiveBox } from 'src/app/pages/petitionDetails/shared/components';
import type { PetitionPhoto } from 'src/app/pages/petitionDetails/shared/types';

import { AddMediaContainer } from '../AddMedia';

import { Photo } from './components/Photo';
import { PhotoMobile } from './components/PhotoMobile';
import { PhotoProcessing } from './components/PhotoProcessing';

type Props = {
	photo?: PetitionPhoto;
};

export const MediaContainer: React.FC<Props> = ({ photo }) => {
	const {
		data: { canEdit },
	} = usePetitionDetailsPageUserData();

	if (photo) {
		if (photo.processing) {
			return <PhotoProcessing />;
		}
		return (
			<>
				<ResponsiveBox viewportSize="small">
					<PhotoMobile id="petition-photo-mobile" url={photo.url} mobileUrl={photo.mobileUrl} />
				</ResponsiveBox>

				<ResponsiveBox viewportSize="normal">
					<Photo id="petition-photo" url={photo.url} mobileUrl={photo.mobileUrl} />
				</ResponsiveBox>
			</>
		);
	}

	if (canEdit) {
		return <AddMediaContainer />;
	}

	return null;
};
